import React, { useState } from "react";

import {
  chakra,
  Box,
  Button,
  Flex,
  Stack,
  Input,
  InputGroup,
  Text,
  FormControl,
  FormErrorMessage,
  Heading
} from "@chakra-ui/react";

import { useForm } from "react-hook-form";
import axios from "axios";
import { BASE_URL } from "../constants/api";
import qs from "qs";
import Home from "./Home";
import { useVoiceprintStore } from "../store";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [accessToken, setAccessToken] = useState(undefined);

  const { setCurrentStep } = useVoiceprintStore();

  // Other Hooks
  const {
    handleSubmit,
    register,
    clearErrors,
    setError,
    formState: { errors, isSubmitting }
  } = useForm();

  const onSubmit = async values => {
    setIsLoading(true);
    try {
      const body = {
        username: values.username,
        password: values.password
      };
      const options = {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: qs.stringify(body),
        url: `${BASE_URL}/user/login`
      };

      axios(options)
        .then(res => {
          if (res.data) {
            console.log("Res----->", res.data);
            setCurrentStep("new");
            setAccessToken(res.data.access_token);
          }
          setIsLoading(false);
        })
        .catch(err => {
          console.error("Login Failed: ", err);
          setError("serverError", {
            message: err?.response?.data?.detail || err.toString()
          });
          setIsLoading(false);
        });
    } catch (err) {
      setError("serverError", {
        message: err?.response?.data?.detail || err.toString()
      });
      setIsLoading(false);
    }

    setTimeout(() => clearErrors(["serverError"]), 3000);
  };

  return (
    <>
      {accessToken !== undefined ? (
        <Home accessToken={accessToken} />
      ) : (
        <Flex minH={"100vh"} align={"center"} justify={"center"} bg="gray.50">
          <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
            <Stack align={"center"}>
              <Heading fontSize={"4xl"}>Sign in to your account</Heading>
              <Text fontSize={"lg"} color={"gray.600"}>
                to test the Voice Biometric Application
              </Text>
            </Stack>

            <Box rounded={"lg"} bg="white" boxShadow={"lg"} p={8}>
              <Stack spacing={4}>
                <chakra.form onSubmit={handleSubmit(onSubmit)}>
                  <FormControl isInvalid={errors.username} mt={6}>
                    <Input
                      placeholder="Username"
                      {...register("username", {
                        required: "Username is required"
                      })}
                    />
                    {errors.username && (
                      <FormErrorMessage>
                        {errors.username.message}
                      </FormErrorMessage>
                    )}
                  </FormControl>
                  <FormControl isInvalid={errors.password} mt={6}>
                    <InputGroup>
                      <Input
                        type="password"
                        placeholder="Password"
                        {...register("password", {
                          required: "Password is required"
                        })}
                      />
                    </InputGroup>
                    {errors.password && (
                      <FormErrorMessage>
                        {errors.password.message}
                      </FormErrorMessage>
                    )}
                  </FormControl>

                  <Button
                    mt={10}
                    w="full"
                    type="submit"
                    bgColor="black"
                    color="white"
                    isLoading={isLoading}
                  >
                    Sign In
                  </Button>
                  {errors.serverError && (
                    <Text color="red" mt={4} textAlign="left">
                      {errors.serverError.message}
                    </Text>
                  )}
                </chakra.form>
              </Stack>
            </Box>
          </Stack>
        </Flex>
      )}
    </>
  );
};

export default Login;
